import Constants from "../../utils/constants";
import { Link } from "react-router-dom";
import { NavLink } from "../../components/common/NavLink";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalStore } from "../../utils/global";
import GlobalLoading from "../../components/common/GlobalLoading";

const WithMainLayout = (
  PageComponent,
  title,
  showHeader = true,
  showHelp = true
) => {
  const asideMenuClose = () => {
    document.body.classList.remove("overflowHidden");
    var nav = document.querySelector(".aside-menu");
    nav?.classList.toggle("open");
  };

  const asideMenuOpen = () => {
    document.body.classList.add("overflowHidden");
    var nav = document.querySelector(".aside-menu");
    nav?.classList.toggle("open");
  };

  return function WithPage({ ...props }) {
    const navigate = useNavigate();
    const { user } = useGlobalStore();

    function logoutClick() {
      navigate(Constants.APPURLS.LOGIN, { replace: true });
    }

    return (
      <>
        <GlobalLoading />
        <main>
          <aside className="aside-menu">
            <div className="block">
              <div className="flex justify-between items-end border-b border-gray-10 mb-12 pb-12">
                <Link to="/" className="inline-block">
                  <img
                    src={require("../../ui/img/logo-afp.png")}
                    className="w-[136px] h-10 object-contain"
                    alt="Logo Afp"
                  />
                </Link>
                <a
                  href="#!"
                  onClick={asideMenuClose}
                  className="btn-icon btn-secondary btn-small inline-flex md:hidden"
                >
                  <i className="icon icon-close text-[8px]"></i>
                </a>
              </div>
              <nav className="main-nav">
                {user && (
                  <NavLink to={Constants.APPURLS.DASHBOARD}>
                    <i className="icon icon-home"></i>Mi Cuenta
                  </NavLink>
                )}
                {user && (
                  <NavLink to={Constants.APPURLS.DISTRIBUTION_FUNDS}>
                    <i className="icon icon-wallet"></i>Reparto de Fondos
                  </NavLink>
                )}
                {user && (
                  <NavLink to={Constants.APPURLS.REQUESTS_SERVICES_CLAIMS}>
                    <i className="icon icon-file"></i>Solicitudes &
                    Reclamaciones
                  </NavLink>
                )}
                {user && (
                  <NavLink to={Constants.APPURLS.BENEFITS}>
                    <i className="icon icon-cashv2"></i>Beneficios
                  </NavLink>
                )}
                <NavLink to={Constants.APPURLS.CALCULATORS}>
                  <i className="icon icon-calculator"></i>Calculadoras
                </NavLink>
                {/* <a href={process.env.REACT_APP_AYUDA_URL} className="nav-item">
                  <i className="icon icon-chat"></i>Centro de Ayuda
                </a> */}
              </nav>
            </div>
            {user && (
              <button
                onClick={logoutClick}
                className="btn btn-secondary btn-large w-full"
              >
                Cerrar Sesión
              </button>
            )}
          </aside>
          <section>
            <div className="content-dashboard">
              {showHeader && (
                <div className="header">
                  <div className="title">
                    <a
                      href="#!"
                      onClick={asideMenuOpen}
                      className="btn-icon btn-secondary btn-small flex md:hidden mr-3 md:mr-[22px]"
                    >
                      <i className="icon icon-menu text-[10px]"></i>
                    </a>

                    <h1 className="text-primary-100 font-bold">{title}</h1>
                  </div>
                  {user && (
                    <Link to="/profile" className="btn-user">
                      <img src={require("../../ui/img/img-profile.png")} alt="Imagen usuario" />
                    </Link>
                  )}
                </div>
              )}

              <PageComponent />

              {/*showHelp && (
                <>
                  <a
                    href="#!"
                    className="btn btn-primary btn-large fixed right-6 bottom-6 rounded-2xl hidden md:inline-flex shadow-base"
                  >
                    <i className="icon icon-chatv2 right size"></i>Ayuda
                  </a>
                  <a
                    href="#!"
                    className="btn-icon btn-primary btn-large fixed right-4 bottom-24 rounded-2xl inline-flex md:hidden shadow-base"
                  >
                    <i className="icon icon-chatv2 text-[20px]"></i>
                  </a>
                </>
              )*/}
            </div>
          </section>
          <nav className="main-nav-resposive">
            <NavLink to={Constants.APPURLS.DASHBOARD} responsive="true">
              <i className="icon icon-home"></i>
              <p>Mi Cuenta</p>
            </NavLink>
            <NavLink
              to={Constants.APPURLS.DISTRIBUTION_FUNDS}
              responsive="true"
            >
              <i className="icon icon-wallet"></i>
              <p>Reparto Fondos</p>
            </NavLink>
            <NavLink
              to={Constants.APPURLS.REQUESTS_SERVICES_CLAIMS}
              responsive="true"
            >
              <i className="icon icon-file"></i>
              <p>Solicitudes</p>
            </NavLink>
            <NavLink to={Constants.APPURLS.BENEFITS} responsive="true">
              <i className="icon icon-cashv2"></i>
              <p>Beneficios</p>
            </NavLink>
          </nav>
        </main>
      </>
    );
  };
};

export default WithMainLayout;
